/** دسترسی به باشگاه مشتریان: نقش admin/superadmin یا پرچم داده‌شده توسط ادمین اصلی (پس از ورود در localStorage). */
export function canAccessCustomerClub(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  if (r === 'admin' || r === 'superadmin') return true;
  return localStorage.getItem('admin_customer_club_access') === '1';
}

export function setCustomerClubAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_customer_club_access', value ? '1' : '0');
}

export function clearCustomerClubAccess(): void {
  localStorage.removeItem('admin_customer_club_access');
}

/** تنظیم سگمنت‌ها: مدیر اصلی یا پرچم جداگانه در مدیریت کاربران. */
export function canEditCustomerClubSegments(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  if (r === 'admin' || r === 'superadmin') return true;
  return localStorage.getItem('admin_customer_club_segments_access') === '1';
}

export function setCustomerClubSegmentsAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_customer_club_segments_access', value ? '1' : '0');
}

export function clearCustomerClubSegmentsAccess(): void {
  localStorage.removeItem('admin_customer_club_segments_access');
}
